import { render, staticRenderFns } from "./proposal-evaluation-detail.vue?vue&type=template&id=b88c5a58&scoped=true&"
import script from "./proposal-evaluation-detail.vue?vue&type=script&lang=ts&"
export * from "./proposal-evaluation-detail.vue?vue&type=script&lang=ts&"
import style0 from "./proposal-evaluation-detail.vue?vue&type=style&index=0&id=b88c5a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c5a58",
  null
  
)

export default component.exports